import { IDealerAddGoal, IMonthlyFinancialSummary } from './dashboardInterfaces';
import { IState } from '..';

export const getMonthlySummaries = (state: IState): IMonthlyFinancialSummary[] => {
  if (state.dashboard.sales) {
    return state.dashboard.sales.monthlyShipments;
  }
  return [];
};

export const getDealerAdds = (state: IState): IDealerAddGoal[] => {
  if (state.dashboard.sales) {
    return state.dashboard.sales.dealerAdds;
  }
  return [];
};

export const getProspectCount = (state: IState): number => {
  if (state.dashboard.sales) {
    return state.dashboard.sales.prospectSummaries.reduce<number>((sum, p) => (sum += p.count), 0);
  }
  return 0;
};

export const getProspectSummaries = (state: IState): { [index: number]: number } => {
  if (state.dashboard.sales) {
    return state.dashboard.sales.prospectSummaries.reduce<{ [index: number]: number }>((hash, s) => {
      hash[s.prospectLifeCycleStepId] = s.count;
      return hash;
    }, {});
  }
  return {};
};
